// src/api/apiClient.js
import axios from 'axios';

const getBaseURL = () => {
  let url = process.env.REACT_APP_API_URL || '';
  // Strip any trailing slash so we have a clean base to append paths to.
  url = url.replace(/\/+$/, '');

  // If the URL is provided but does not end with /api, append it.
  // This handles cases where the user forgets the /api suffix in production env vars.
  if (url && !url.endsWith('/api')) {
    url = `${url}/api`;
  }

  return url ? `${url}/` : '/';
};

const apiClient = axios.create({
  baseURL: getBaseURL(),
  headers: {
    'Content-Type': 'application/json'
  }
});

// Interceptor to add the JWT token to every outgoing request
// AND ensure request paths don't start with / when using a baseURL with a path prefix.
// Axios treats a path starting with "/" as absolute (ignores baseURL), so we strip it.
apiClient.interceptors.request.use(
  (config) => {
    // 1. Add Auth Token
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    // 2. Strip leading slash so Axios correctly joins with the baseURL
    //    e.g. baseURL="https://cyberjugs.onrender.com/api/" + "challenges/123"
    //    NOT  baseURL="https://cyberjugs.onrender.com/api/" + "/challenges/123"
    //         (the latter would resolve to "https://cyberjugs.onrender.com/challenges/123" — wrong!)
    if (config.url && config.url.startsWith('/')) {
      config.url = config.url.substring(1);
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default apiClient;
